import { Identifiable, Resource, CalendarExportLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getCalendarExportLinks(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarExportLink>>({
        endpoint: `/calendarLinks/${resource.uuid}/link`,
        method: HttpMethods.GET,
      })
      .then((response) => [
        {
          ...response,
          uri: response.uri,
        },
      ]);
}

export { getCalendarExportLinks };
